/* G21 Footer
   File: assets/g21-footer.js
*/
(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState !== 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  function enhanceFooter(footer) {
    if (!footer || footer.dataset.g21FooterReady === 'true') return;
    footer.dataset.g21FooterReady = 'true';

    var links = footer.querySelectorAll('a[href^="http"]:not([target])');
    links.forEach(function (link) {
      var url = new URL(link.href, window.location.href);
      if (url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
      }
    });

    var newsletter = footer.querySelector('.g21-footer__newsletter-form');
    if (newsletter) {
      newsletter.addEventListener('submit', function () {
        var button = newsletter.querySelector('button[type="submit"]');
        if (button) {
          button.dataset.originalText = button.textContent;
          button.textContent = 'SENDING...';
          button.disabled = true;
          setTimeout(function () {
            if (button) {
              button.textContent = button.dataset.originalText || 'SUBSCRIBE';
              button.disabled = false;
            }
          }, 4500);
        }
      });
    }

    var whatsappLinks = footer.querySelectorAll('a[href*="wa.me/"]');
    whatsappLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        link.classList.add('g21-footer__whatsapp--clicked');
        setTimeout(function () {
          link.classList.remove('g21-footer__whatsapp--clicked');
        }, 800);
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-g21-footer]').forEach(enhanceFooter);

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        event.target.querySelectorAll('[data-g21-footer]').forEach(enhanceFooter);
      }
    });
  });
})();
